import { Badge, Button, Input, Row } from "reactstrap";
import MonacoEditor from "@monaco-editor/react";
import { useEffect, useState } from "react";
import { MdDelete, MdEdit, MdPlayArrow, MdSave } from "react-icons/md";
import Console from "../../../Console";

function CodeEditor({
  functionName,
  code,
  onChange,
  onSave,
  onRename,
  variables = [],
  variables_output = [],
  onPressVariable,
}) {
  const [currentCode, setCurrentCode] = useState(code);
  const [renameActive, setRenameActive] = useState(false);
  const [funcName, setFuncName] = useState(functionName);
  const [consoleHeight, setConsoleHeight] = useState(160);

  const [consoleResult, setConsoleResult] = useState("");

  useEffect(() => {
    setCurrentCode(code);
  }, [code]);

  useEffect(() => {
    setFuncName(functionName);
  }, [functionName]);

  const handleEditorChange = (value) => {
    setCurrentCode(value);
    onChange?.(value);
  };

  const handleSaveRename = () => {
    setRenameActive(false);
    onRename?.(funcName);
  };

  return (
    <div style={{ borderWidth: 1, borderColor: "white" }}>
      <div style={{ padding: 0 }}>
        <div className="active-code">
          <div>
            {!renameActive ? (
              <span
                className="function-name"
                onClick={() => setRenameActive(true)}
              >
                <MdEdit color="var(--primary)" style={{ marginRight: 5 }} />
                {funcName}
              </span>
            ) : (
              <div className="rename-active">
                <Input
                  value={funcName}
                  onChange={(e) => setFuncName(e.target.value)}
                />
                <Button
                  color="primary"
                  onClick={handleSaveRename}
                  style={{ height: 30, width: 35, padding: 4 }}
                >
                  <MdSave size={10} />
                </Button>
              </div>
            )}
          </div>
          <div className="active-actions">
            <Button
              color="primary"
              className="button-mid-height"
              onClick={onSave}
              style={{ fontSize: 12 }}
            >
              <MdSave /> Salvar
            </Button>

            {/* <Button
              className="button-mid-height"
              color="success"
              style={{ fontSize: 12 }}
            >
              <MdPlayArrow /> Rodar
            </Button> */}
          </div>
        </div>
        <div style={{ marginTop: 5 }}>
          <MonacoEditor
            height={`calc(100vh - 120px - ${consoleHeight}px)`}
            language="python"
            theme="light"
            value={currentCode}
            onChange={handleEditorChange}
          />
        </div>
      </div>

      <div>
        <div
          style={{
            padding: 5,
            display: "column",
            alignItems: "center",
          }}
        >
          <div>
            <span
              style={{
                fontSize: 10,
                fontWeight: "500",
                color: "var(--bs-secondary)",
                marginRight: 5,
              }}
            >
              Saídas:{" "}
            </span>
            {variables_output.map((e) => (
              <Badge
                color="secondary"
                className="variable-console"
                onClick={() => onPressVariable(e)}
              >
                {e.label}
              </Badge>
            ))}
          </div>
          <div style={{ marginTop: 5 }}>
            <span
              style={{
                fontSize: 10,
                fontWeight: "500",
                color: "var(--bs-secondary)",
                marginRight: 15,
              }}
            >
              Entradas:{" "}
            </span>
            {variables.map((e) => (
              <Badge
                color="info"
                className="variable-console"
                onClick={() => onPressVariable(e)}
              >
                {e.label}
              </Badge>
            ))}
          </div>
        </div>
        <Console
          result={consoleResult}
          setConsoleHeight={setConsoleHeight}
          consoleHeight={consoleHeight}
        />
      </div>
    </div>
  );
}

export default CodeEditor;
